import { useEffect, useState } from 'react';
import { getApiLoadingCount, subscribeToApiLoading } from '../utils/api';

export const useApiLoading = () => {
  const [count, setCount] = useState<number>(getApiLoadingCount());

  useEffect(() => {
    const unsubscribe = subscribeToApiLoading(setCount);
    return () => {
      unsubscribe();
    };
  }, []);

  return count > 0;
};

